import {
  ESSENTIALS_PAID_PLAN,
  PODIUM_PAID_PLAN,
  PROFESSIONAL_PAID_PLAN,
} from '../../screens/Trials/constants';

export const PACKAGES = {
  ESSENTIALS: 'ESSENTIALS',
  STANDARD: 'STANDARD',
  PROFESSIONAL: 'PROFESSIONAL',
};

export const BUNDLE_PACKAGES_LIST = Object.keys(PACKAGES);

export const BUY_NOW_CARDS = [
  {
    bundle: PACKAGES.ESSENTIALS,
    bundlePlanName: ESSENTIALS_PAID_PLAN,
    cardId: 'buy-now-essentials',
    description: 'Ideal for small businesses who are just taking off.',
    discountPercentage: 10,
    price: 289,
    term: 'month',
    title: 'Essentials',
  },
  {
    bundle: PACKAGES.STANDARD,
    bundlePlanName: PODIUM_PAID_PLAN,
    cardId: 'buy-now-standard',
    description: "For expanding businesses that don't want plan limits.",
    discountPercentage: 10,
    price: 449,
    showPopularText: true,
    term: 'month',
    title: 'Standard',
  },
  {
    bundle: PACKAGES.PROFESSIONAL,
    bundlePlanName: PROFESSIONAL_PAID_PLAN,
    cardId: 'buy-now-professional',
    description: 'Advanced business solutions a mature business needs.',
    discountPercentage: 10,
    price: 649,
    term: 'month',
    title: 'Professional',
  },
];

export const PACKAGE_TITLES = {
  [PACKAGES.ESSENTIALS]: 'Essentials',
  [PACKAGES.STANDARD]: 'Standard',
  [PACKAGES.PROFESSIONAL]: 'Professional',
};

export const PACKAGE_CARD_DESCRIPTIONS = {
  [PACKAGES.ESSENTIALS]:
    'Ideal for small businesses who are getting started or for the self-employed',
  [PACKAGES.STANDARD]:
    'Perfect for businesses that are expanding, online and in person',
  [PACKAGES.PROFESSIONAL]:
    'All the advanced business solutions a mature business needs ',
};

export const PACKAGE_CARD_IS_POPULAR = {
  [PACKAGES.ESSENTIALS]: false,
  [PACKAGES.STANDARD]: true,
  [PACKAGES.PROFESSIONAL]: false,
};

export const PACKAGE_CARD_SUBHEADERS = {
  [PACKAGES.ESSENTIALS]: 'Get these powerful features:',
  [PACKAGES.STANDARD]: 'All of the benefits of Essentials, and:',
  [PACKAGES.PROFESSIONAL]: 'All of the benefits of Standard, and:',
};

export const PACKAGE_PRICES = {
  [PACKAGES.ESSENTIALS]: '289',
  [PACKAGES.STANDARD]: '449',
  [PACKAGES.PROFESSIONAL]: '649',
};

export const PACKAGE_PRICES_MONTHLY = {
  [PACKAGES.ESSENTIALS]: '289',
  [PACKAGES.STANDARD]: '449',
  [PACKAGES.PROFESSIONAL]: '649',
};

export const PACKAGE_PRICES_YEARLY = {
  [PACKAGES.ESSENTIALS]: '249',
  [PACKAGES.STANDARD]: '409',
  [PACKAGES.PROFESSIONAL]: '599',
};

export const PACKAGE_TOPHIGHLIGHTS = {
  [PACKAGES.ESSENTIALS]: [
    {
      hovertext:
        '"Contacts" are any customers you use Podium to communicate with',
      strong: '1,000 ',
      normal: 'contacts',
    },
    {
      hovertext: 'The number of team members with access to Podium',
      strong: 'Up to 3 ',
      normal: 'team members',
    },
  ],
  [PACKAGES.STANDARD]: [
    {
      hovertext:
        '"Contacts" are any customers you use Podium to communicate with',
      strong: 'Unlimited ',
      normal: 'contacts',
    },
    {
      hovertext: 'The number of team members with access to Podium',
      strong: 'Unlimited ',
      normal: 'team members',
    },
  ],
  [PACKAGES.PROFESSIONAL]: [
    {
      hovertext:
        '"Contacts" are any customers you use Podium to communicate with',
      strong: 'Unlimited ',
      normal: 'contacts',
    },
    {
      hovertext: 'The number of team members with access to Podium',
      strong: 'Unlimited ',
      normal: 'team members',
    },
  ],
};

export const PACKAGE_HIGHLIGHTS = {
  [PACKAGES.ESSENTIALS]: [
    'Capture online reviews instantly',
    'A text-based website chat',
    'Easy-to-use text-marketing',
    'Secure & simple payment processing ',
  ],
  [PACKAGES.STANDARD]: [
    'Personalized setup & onboarding',
    '100s of app integrations',
    'Website reporting & customization',
    'Automated review invitations',
    'Customized branding',
  ],
  [PACKAGES.PROFESSIONAL]: [
    'Automations that streamline tasks',
    'Round-robin lead routing',
    'Personalized automated FAQs ',
    'Advanced payment options',
    'Multimedia marketing messages',
  ],
};

export const LIMITS_FEATURE_LIST = [
  {
    title: 'Contacts',
    hoverText:
      '"Contacts" are any customers you use Podium to communicate with.',
    [PACKAGES.ESSENTIALS]: 'Starting at 1,000',
    [PACKAGES.STANDARD]: 'Unlimited',
    [PACKAGES.PROFESSIONAL]: 'Unlimited',
  },
  {
    title: 'Marketing Contacts',
    hoverText:
      '"Marketing Contacts" are customers that have agreed to receive marketing texts from your business.',
    [PACKAGES.ESSENTIALS]: 'Starting at 100',
    [PACKAGES.STANDARD]: 'Starting at 500',
    [PACKAGES.PROFESSIONAL]: 'Starting at 1,000',
  },
  {
    title: 'Team Members',
    hoverText: 'The number of team members with access to Podium',
    [PACKAGES.ESSENTIALS]: '3',
    [PACKAGES.STANDARD]: 'Unlimited',
    [PACKAGES.PROFESSIONAL]: 'Unlimited',
  },
];

export const BASIC_COMMUNICATION_FEATURE_LIST = [
  {
    title: 'Inbox',
    hoverText:
      'All your texts, emails, phone calls, and social media messaging in one place',
    [PACKAGES.ESSENTIALS]: true,
    [PACKAGES.STANDARD]: true,
    [PACKAGES.PROFESSIONAL]: true,
  },
  {
    title: 'Customer Database',
    hoverText:
      'Automatically records all customer information and interaction history',
    [PACKAGES.ESSENTIALS]: true,
    [PACKAGES.STANDARD]: true,
    [PACKAGES.PROFESSIONAL]: true,
  },
  {
    title: 'Text Marketing Campaigns',
    hoverText: 'Send text message marketing campaigns',
    [PACKAGES.ESSENTIALS]: true,
    [PACKAGES.STANDARD]: true,
    [PACKAGES.PROFESSIONAL]: true,
  },
  {
    title: 'Reviews',
    hoverText:
      'Easily collect reviews on Google and Facebook by sending a text ',
    [PACKAGES.ESSENTIALS]: true,
    [PACKAGES.STANDARD]: true,
    [PACKAGES.PROFESSIONAL]: true,
  },
  {
    title: 'Website Chat Widget',
    hoverText:
      'Customers start conversations on your website and then text you on the go',
    [PACKAGES.ESSENTIALS]: true,
    [PACKAGES.STANDARD]: true,
    [PACKAGES.PROFESSIONAL]: true,
  },
  {
    title: 'Call-to-Text',
    hoverText:
      'Customers have the option to move the conversation to text when they call',
    [PACKAGES.ESSENTIALS]: true,
    [PACKAGES.STANDARD]: true,
    [PACKAGES.PROFESSIONAL]: true,
  },
  {
    title: 'Teamchat',
    hoverText: 'Chat internally with your team members',
    [PACKAGES.ESSENTIALS]: true,
    [PACKAGES.STANDARD]: true,
    [PACKAGES.PROFESSIONAL]: true,
  },
  {
    title: 'Custom Message Templates',
    hoverText: 'Create your own reusable and automated message templates',
    [PACKAGES.ESSENTIALS]: true,
    [PACKAGES.STANDARD]: true,
    [PACKAGES.PROFESSIONAL]: true,
  },
];

export const ADVANCED_COMMUNICATION_FEATURE_LIST = [
  {
    title: 'Voicemail Transcriptions',
    hoverText: 'Get a text version of voicemails sent to the Inbox',
    [PACKAGES.ESSENTIALS]: false,
    [PACKAGES.STANDARD]: true,
    [PACKAGES.PROFESSIONAL]: true,
  },
  {
    title: 'One-click Automations',
    hoverText:
      'Automatically take follow up actions after receiving Reviews, Payments, and more',
    [PACKAGES.ESSENTIALS]: false,
    [PACKAGES.STANDARD]: true,
    [PACKAGES.PROFESSIONAL]: true,
  },
  {
    title: 'Integrations',
    hoverText: 'Set up integrations with other business tools',
    [PACKAGES.ESSENTIALS]: false,
    [PACKAGES.STANDARD]: true,
    [PACKAGES.PROFESSIONAL]: true,
  },
  {
    title: 'Auto FAQ Response',
    hoverText: 'Instantly respond to common customer questions',
    [PACKAGES.ESSENTIALS]: false,
    [PACKAGES.STANDARD]: false,
    [PACKAGES.PROFESSIONAL]: true,
  },
  {
    title: 'Round Robin Routing',
    hoverText:
      'Automatically assign messages to your team by availability for faster response',
    [PACKAGES.ESSENTIALS]: false,
    [PACKAGES.STANDARD]: false,
    [PACKAGES.PROFESSIONAL]: true,
  },
  {
    title: 'Topic-Based Routing',
    hoverText: 'Automatically send messages to the team members by topic',
    [PACKAGES.ESSENTIALS]: false,
    [PACKAGES.STANDARD]: false,
    [PACKAGES.PROFESSIONAL]: true,
  },
];

export const PAYMENTS_FEATURE_LIST = [
  {
    title: 'Text-to-Pay Processing Rate',
    hoverText:
      'The rate is charged per transaction. This functionality includes email-to-pay',
    [PACKAGES.ESSENTIALS]: '2.7% and $0.30',
    [PACKAGES.STANDARD]: '2.6% and $0.30',
    [PACKAGES.PROFESSIONAL]: '2.5% and $0.30',
  },
  {
    title: 'In-Person Processing Rate',
    hoverText: 'Available only in the US. The rate is charged per transaction.',
    [PACKAGES.ESSENTIALS]: '2.2% and $0.15',
    [PACKAGES.STANDARD]: '2.2% and $0.15',
    [PACKAGES.PROFESSIONAL]: '2.1% and $0.15',
  },
  {
    title: 'Manual Entry Processing Rate',
    hoverText:
      'Transactions that are keyed in. The rate is charged per transaction.',
    [PACKAGES.ESSENTIALS]: '2.9% and $0.30',
    [PACKAGES.STANDARD]: '2.9% and $0.30',
    [PACKAGES.PROFESSIONAL]: '2.9% and $0.30',
  },
  {
    title: 'ACH Transfers',
    hoverText: 'Only available to US merchants',
    [PACKAGES.ESSENTIALS]: '0.7% ($1 min, $5 max)',
    [PACKAGES.STANDARD]: '0.7% ($1 min, $5 max)',
    [PACKAGES.PROFESSIONAL]: '0.7% ($1 min, $5 max)',
  },
  {
    title: 'Premium Fraud Protection',
    hoverText: 'Available to select users',
    [PACKAGES.ESSENTIALS]: '0.65%',
    [PACKAGES.STANDARD]: '0.65%',
    [PACKAGES.PROFESSIONAL]: '0.65%',
  },
];

export const MARKETING_FEATURE_LIST = [
  {
    title: 'Text Marketing Campaigns',
    hoverText: 'Send text message marketing campaigns to Marketing Contacts.',
    [PACKAGES.ESSENTIALS]: true,
    [PACKAGES.STANDARD]: true,
    [PACKAGES.PROFESSIONAL]: true,
  },
  {
    title: 'Basic Segmentation',
    hoverText:
      'Organize and target Marketing Contacts for more effective text marketing',
    [PACKAGES.ESSENTIALS]: false,
    [PACKAGES.STANDARD]: true,
    [PACKAGES.PROFESSIONAL]: true,
  },
  {
    title: 'Advanced Segmentation',
    hoverText: 'Automate contact segmentation',
    [PACKAGES.ESSENTIALS]: false,
    [PACKAGES.STANDARD]: true,
    [PACKAGES.PROFESSIONAL]: true,
  },
  {
    title: 'Remove Podium Branding',
    hoverText: 'Remove "Powered by Podium" branding on all messages',
    [PACKAGES.ESSENTIALS]: false,
    [PACKAGES.STANDARD]: true,
    [PACKAGES.PROFESSIONAL]: true,
  },
  {
    title: 'Customized Website Branding',
    hoverText: 'Add your branding to the Webchat website widget',
    [PACKAGES.ESSENTIALS]: false,
    [PACKAGES.STANDARD]: true,
    [PACKAGES.PROFESSIONAL]: true,
  },
  {
    title: 'Website Browsing History',
    hoverText:
      "Target marketing to your customers based on the webpages they've visited",
    [PACKAGES.ESSENTIALS]: false,
    [PACKAGES.STANDARD]: true,
    [PACKAGES.PROFESSIONAL]: true,
  },
  {
    title: 'Multimedia Marketing Messages',
    hoverText:
      'Include images, video and other media in text-message marketing campaigns ',
    [PACKAGES.ESSENTIALS]: false,
    [PACKAGES.STANDARD]: false,
    [PACKAGES.PROFESSIONAL]: true,
  },
];

export const SUPPORT_ONBOARDING_FEATURE_LIST = [
  {
    title: '24/7 Phone and Email Support',
    [PACKAGES.ESSENTIALS]: true,
    [PACKAGES.STANDARD]: true,
    [PACKAGES.PROFESSIONAL]: true,
  },
  {
    title: 'Chat & Text 15/7',
    [PACKAGES.ESSENTIALS]: true,
    [PACKAGES.STANDARD]: true,
    [PACKAGES.PROFESSIONAL]: true,
  },
  {
    title: 'Onboarding',
    secondHoverText: 'Group onboarding through a video webinar.',
    thirdHoverText: 'One-on-one onboarding with a member of the Podium team.',
    fourthHoverText: 'One-on-one onboarding with a member of the Podium team.',
    [PACKAGES.ESSENTIALS]: 'Webinar Onboarding',
    [PACKAGES.STANDARD]: 'One-on-One Onboarding',
    [PACKAGES.PROFESSIONAL]: 'One-on-One Onboarding',
  },
];

export const PACKAGE_NAME_VARIATIONS = {
  essentials: PACKAGES.ESSENTIALS,
  ESSENTIALS: PACKAGES.ESSENTIALS,
  essentials_v2_trial: PACKAGES.ESSENTIALS,
  podium: PACKAGES.STANDARD,
  podium_trial: PACKAGES.STANDARD,
  PODIUM: PACKAGES.STANDARD,
  professional: PACKAGES.PROFESSIONAL,
  PROFESSIONAL: PACKAGES.PROFESSIONAL,
  professional_trial: PACKAGES.PROFESSIONAL,
};

export const PLAN_PACKAGES = {
  [PACKAGES.ESSENTIALS]: {
    annualPrice: '',
    displayName: 'Essentials Plan',
    monthlyPrice: PACKAGE_PRICES[PACKAGES.ESSENTIALS],
    plan: ESSENTIALS_PAID_PLAN,
  },
  [PACKAGES.STANDARD]: {
    annualPrice: '',
    displayName: 'Standard Plan',
    monthlyPrice: PACKAGE_PRICES[PACKAGES.STANDARD],
    plan: PODIUM_PAID_PLAN,
  },
  [PACKAGES.PROFESSIONAL]: {
    annualPrice: '',
    displayName: 'Professional Plan',
    monthlyPrice: PACKAGE_PRICES[PACKAGES.PROFESSIONAL],
    plan: PROFESSIONAL_PAID_PLAN,
  },
};

export const PRICING_PACKAGING_HEADER_TITLE =
  'Simple plans built for local businesses like yours.';

export const MONTHLY_TERM = 'monthly';
export const YEARLY_TERM = 'annual';

export const DISPLAY_MONTH_TERM = 'month';
export const DISPLAY_YEAR_TERM = 'year';
